import React from 'react'
import { t } from '@lingui/macro'
import { LoginForm } from './components/LoginForm/LoginForm'
import { SectionHeader, Header } from 'pages/native/onBoarding/components'
import { useHistory } from 'react-router-dom'
import {
  nativePublicPathGenerator,
  NATIVE_PUBLIC_ROUTES
} from 'routes/native/PublicRoutes'
import { useCompanyName } from 'pages/native/onBoarding/context/OnBoardingContext'

import styles from './LoginPage.module.scss'

export const LoginPage = () => {
  const history = useHistory()
  const { value: company } = useCompanyName()

  return (
    <div className={styles.PageContainer}>
      <Header back={() => history.goBack()} />
      <div className={styles.ContentContainer}>
        <SectionHeader
          title={t`Welcome back!`}
          body={t`Already have an account? Log in to stay connected and pick up where
          you left off.`}
          textAlign="left"
        />
        <LoginForm
          onForgotPasswordClick={() =>
            history.push(
              nativePublicPathGenerator(
                NATIVE_PUBLIC_ROUTES.AUTH.FORGOT_PASSWORD,
                company
              )
            )
          }
        />
      </div>
    </div>
  )
}
